export default __webpack_public_path__ + "static/media/helmet-icon.adfdd7cd.svg";